module.exports = __webpack_public_path__ + "0c48fc8473e1df11b01cbbe95036d7ce.png";